/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Invite_TitleInputs */

const en_mobile_referral_invite_title = /** @type {(inputs: Mobile_Referral_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite friends`)
};

const es_mobile_referral_invite_title = /** @type {(inputs: Mobile_Referral_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita amigos`)
};

/**
* | output |
* | --- |
* | "Invite friends" |
*
* @param {Mobile_Referral_Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_invite_title = /** @type {((inputs?: Mobile_Referral_Invite_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Invite_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_invite_title(inputs)
	return en_mobile_referral_invite_title(inputs)
});